<template>
    <div>
        <ui-icon-button ref="button" has-dropdown icon="flag" type="secondary" style="vertical-align: middle;" tooltip="Update Status">
            <div slot="dropdown">
                <div class="container-fluid">
                    <div @click="setStatus(status)" v-for="status in statuses" class="row align-items-center">
                        <div class="col">{{ status.label }}</div>
                        <div class="col-4"><span class="material-icons">{{ isCurrentStatus(status) ? 'check' : '' }}</span></div>
                    </div>
                </div>
            </div>
        </ui-icon-button>
    </div>
</template>

<script>
    import {autoRespondEnabled} from "../../../ts/Inbox/CruiseControl";

    const statuses = [
        {
            label: 'Waiting',
            value: 'waiting',
        },{
            label: 'Follow Up',
            value: 'follow-up',
        },{
            label: 'Closed',
            value: 'closed',
        },{
            label: 'Bin',
            value: 'bin',
        },{
            label: 'Junk',
            value: 'junk',
        }
    ]

    if (autoRespondEnabled()) {
        statuses.unshift({
            label: 'AI',
            value: 'ai',
        })
    }

    export default {
        props: {
            conversations: {
              type: Array,
              required: true
            },
        },
        data() {
            return {
                statuses
            }
        },
        methods: {
            setStatus(status) {
                let promises = []

                for (let i in this.conversations) {
                    promises.push(this.$store.dispatch(
                        'inbox/conversations/status', {
                            conversation_id: this.conversations[i].id,
                            status: status.value
                        }
                    ))
                }

                Promise.all(promises).then(() => {
                    this.$emit('changed')

                    if (this.$refs.button) {
                        this.$refs.button.closeDropdown()
                    }
                })
            },
            isCurrentStatus(status) {
                if (this.conversations.length === 1) {
                    return status.value === this.conversations[0].status
                }

                return false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-fluid {
        width: 200px;

        .row {
            border-top: 1px solid #eee;
            padding-top: .5rem;
            padding-bottom: .5rem;
            cursor: pointer;

            &:hover { background: #f8f8f8; }
        }

        .material-icons { vertical-align: middle; min-height: 24px; }
    }
</style>